import {GrClose} from 'react-icons/gr';
import './styles.css';

function index(props) {
    const {images, title, text, setOpen, copyright} = props;

    const topImages = images.slice(0, 3);
    const desktopBottom = images.slice(3);
    const mobileBottom = images.slice(1);

    return (
        <>
            <div className="case-modal-background" onClick={() => setOpen(false)} />

            <div className="case-modal">
                <GrClose className='close-icon' onClick={() => setOpen(false)} />

                <div className={`images-section${topImages.length < 3 ? ' images-centered' : ''}`}>
                    {topImages.map((image, i) =>
                        <img key={i} src={image} alt="Imagem do projeto" className={i > 0 ? 'img-secondary' : ''} />
                    )}
                </div>

                {copyright && <p className='copyright'>{copyright}</p>}
                <h2>{title}</h2>
                {text}

                {desktopBottom.length > 0 && (
                    <div className='images-bottom desktop-bottom'>
                        {desktopBottom.map((image, i) =>
                            <img key={i} src={image} alt="Imagem do projeto" />
                        )}
                    </div>
                )}

                {mobileBottom.length > 0 && (
                    <div className='images-bottom mobile-bottom'>
                        {mobileBottom.map((image, i) =>
                            <img key={i} src={image} alt="Imagem do projeto" />
                        )}
                    </div>
                )}
            </div>
        </>
    )
}

export default index;
